<script setup lang="ts">
import { navigateTo } from '#app'
import { onMounted, ref } from 'vue'
import { useAuthStore } from '../stores/authStore'
import TopBar from '../components/TopBar.vue'
import MenuPanel from '../components/MenuPanel.vue'

const loading = ref(true)

onMounted(async () => {
  const auth = useAuthStore()

  await auth.refreshSession()

  if (!auth.authorized) {
    await navigateTo('/login/')
    return
  }

  loading.value = false
})
</script>

<template>
  <div v-if="!loading">
    <TopBar />
    <div class="flex flex-row">
      <div>
        <MenuPanel />
      </div>
      <main class="p-10 bg-cms-dark-white max-h-[calc(100svh-32px)] w-full overflow-auto">
        <slot />
      </main>
    </div>
    <DynamicDialog />
    <Toast />
  </div>
  <div
    v-else
    class="hidden"
  >
    <slot />
  </div>
</template>
